// Shared home for the requirement-reference sentinel prefixes, so a display/validation path that
// doesn't know which field it's looking at (JsonPrettyView, validatePolicyForm) can still
// recognize a group, named location, application, user, directory role, authentication context,
// service principal, authentication strength, or custom authentication factor requirement
// reference without guessing. Each domain (groupRequirement.util.js,
// namedLocationRequirement.util.js, applicationRequirement.util.js, userRequirement.util.js,
// directoryRoleRequirement.util.js, authenticationContextRequirement.util.js,
// servicePrincipalRequirement.util.js, customAuthenticationFactorRequirement.util.js) owns its own
// prefix and isRequirementRef/getRequirementId/toRequirementRef built from it; this file only
// combines the prefixes for the generic case.
export const GROUP_REQUIREMENT_REF_PREFIX = 'group:'
export const LOCATION_REQUIREMENT_REF_PREFIX = 'location:'
export const APPLICATION_REQUIREMENT_REF_PREFIX = 'application:'
export const USER_REQUIREMENT_REF_PREFIX = 'user:'
export const ROLE_REQUIREMENT_REF_PREFIX = 'role:'
export const AUTHENTICATION_CONTEXT_REQUIREMENT_REF_PREFIX = 'authContext:'
export const SERVICE_PRINCIPAL_REQUIREMENT_REF_PREFIX = 'servicePrincipal:'
export const AUTHENTICATION_STRENGTH_REQUIREMENT_REF_PREFIX = 'authStrength:'
export const CUSTOM_AUTHENTICATION_FACTOR_REQUIREMENT_REF_PREFIX = 'customFactor:'

const ALL_REQUIREMENT_REF_PREFIXES = [
  GROUP_REQUIREMENT_REF_PREFIX,
  LOCATION_REQUIREMENT_REF_PREFIX,
  APPLICATION_REQUIREMENT_REF_PREFIX,
  USER_REQUIREMENT_REF_PREFIX,
  ROLE_REQUIREMENT_REF_PREFIX,
  AUTHENTICATION_CONTEXT_REQUIREMENT_REF_PREFIX,
  SERVICE_PRINCIPAL_REQUIREMENT_REF_PREFIX,
  AUTHENTICATION_STRENGTH_REQUIREMENT_REF_PREFIX,
  CUSTOM_AUTHENTICATION_FACTOR_REQUIREMENT_REF_PREFIX,
]

export const isAnyRequirementRef = (value) =>
  typeof value === 'string' && ALL_REQUIREMENT_REF_PREFIXES.some((prefix) => value.startsWith(prefix))

export const getAnyRequirementId = (value) => {
  if (typeof value !== 'string') {
    return null
  }
  const prefix = ALL_REQUIREMENT_REF_PREFIXES.find((p) => value.startsWith(p))
  return prefix ? value.slice(prefix.length) : null
}
